import {extractLang, loadLang} from './languages';
import {hasLineNumbers, loadLineNumbers} from './plugins';

const init = async (codeEl) => {
    if (!codeEl) {
        console.warn('No `code` element provided to Prism initialisation');
        return;
    }

    const Prism = await import('prismjs');
    await import('prism-themes/themes/prism-one-light.css');

    const lang = extractLang(codeEl);
    await loadLang(lang);

    if (hasLineNumbers(codeEl)) {
        await loadLineNumbers();
    }

    Prism.highlightElement(codeEl);
};

export {init};
